export default "__VITE_ASSET__ci1QRYjM__"